import { createAction, props } from "@ngrx/store";
import { Role } from "src/app/_models/Role";
import { RoleActionTypes } from "src/app/constants/StoreConstants";

export const GetAdministratorRoles = createAction(
  RoleActionTypes.GetAdministratorRoles
)

export const GetAdministratorRolesSuccess = createAction(
  RoleActionTypes.GetAdministratorRolesSuccess,
  props<{result: Role[]}>()
)

export const GetAdministratorRolesError = createAction(
  RoleActionTypes.GetAdministratorRolesError,
  props<{error: any}>()
)